//@ts-ignore
import { twMerge } from 'tailwind-merge';
import { ICommonProps } from '..';

interface ILocationSection extends Partial<ICommonProps> {
  locationTitle?: string;
}

export const LocationSection = ({ className, locationTitle }: ILocationSection) => {
  return (
    <div className={twMerge('flex items-center gap-1 w-fit', className)}>
      {/* <MyLocationIcon /> */}
      <span className='small text-secondaryMineShaft'>{locationTitle}.</span>
    </div>
  );
};
